module.exports = __webpack_public_path__ + "img/gtbrdd-square.ce766e99.jpeg";